(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner-slider"] && !Shopify.designMode) return;
  try {
    
  class CollectionBannerSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-cbs-viewport]');
      this.slides = Array.from(this.querySelectorAll('.cbs__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-cbs-dot]'));
      this.live = this.querySelector('[data-cbs-live]');
      this.prevBtn = this.querySelector('[data-cbs-prev]');
      this.nextBtn = this.querySelector('[data-cbs-next]');

      if (this.slides.length === 0) return;

      this.index = 0;
      this.count = this.slides.length;
      this.loop = this.dataset.loop === 'true';
      this.swipeEnabled = this.dataset.swipe === 'true';
      this.mode = this.dataset.transition || 'dissolve-left';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;
      this.animating = false;

      this.layout();
      this.bind();
      this.initFlow();
      if (this.autoplay && !this.reduced) this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.flowScroll) {
        window.removeEventListener('scroll', this.flowScroll);
        window.removeEventListener('resize', this.flowResize);
      }
      if (this.onPointerMove) {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }
    }

    /* Parallax drift. Browsers with scroll-driven animations do this in CSS,
       off the main thread. This is the fallback for the ones that don't. */
    initFlow() {
      if (this.dataset.flow !== 'true' || this.reduced) return;
      if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) return;

      this.flowGroups = Array.from(this.querySelectorAll('.cbs__content-inner'));
      this.flowTrails = Array.from(this.querySelectorAll('.cbs__btn'));
      if (!this.flowGroups.length) return;

      const read = () => {
        const cs = getComputedStyle(this);
        return {
          amt: parseFloat(cs.getPropertyValue('--cbs-flow')) || 40,
          lag: parseFloat(cs.getPropertyValue('--cbs-flow-lag')) || 0.45
        };
      };

      let cfg = read();
      let ticking = false;

      const paint = () => {
        ticking = false;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const rect = this.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;

        const raw = (vh - rect.top) / (vh + rect.height);
        const p = Math.min(Math.max(raw, 0), 1);
        const offset = (p - 0.5) * 2 * cfg.amt;

        this.flowGroups.forEach((el) => {
          el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
        });
        this.flowTrails.forEach((el) => {
          el.style.transform = 'translate3d(0,' + (offset * cfg.lag).toFixed(2) + 'px,0)';
        });
      };

      this.flowScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(paint);
      };

      this.flowResize = () => { cfg = read(); this.flowScroll(); };

      window.addEventListener('scroll', this.flowScroll, { passive: true });
      window.addEventListener('resize', this.flowResize, { passive: true });
      paint();
    }

    /* Position every non-active slide to the left (-1) or right (1) of the
       active one, so the CSS transform picks the correct direction. */
    layout() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.dataset.active = active ? 'true' : 'false';
        slide.style.setProperty('--cbs-pos', i < this.index ? -1 : 1);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
        slide.querySelectorAll('a, button').forEach((el) => {
          if (active) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });

      if (!this.loop) {
        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
      }

      if (this.live) this.live.textContent = `Slide ${this.index + 1} of ${this.count}`;
    }

    goTo(next, userInitiated) {
      if (this.count < 2) return;

      if (next < 0) {
        if (!this.loop) return;
        next = this.count - 1;
      }
      if (next > this.count - 1) {
        if (!this.loop) return;
        next = 0;
      }
      if (next === this.index) return;

      const forward = next > this.index;

      /* Park the incoming slide on the correct side before it animates in,
         so a "previous" move enters from the left rather than the right. */
      this.slides[next].style.setProperty('--cbs-pos', forward ? 1 : -1);
      this.slides[this.index].style.setProperty('--cbs-pos', forward ? -1 : 1);

      this.index = next;
      this.layout();

      if (userInitiated && this.autoplay) this.restart();
    }

    next(user) { this.goTo(this.index + 1, user); }
    prev(user) { this.goTo(this.index - 1, user); }

    start() {
      this.stop();
      this.timer = setInterval(() => {
        if (this.index === this.count - 1 && !this.loop) return this.stop();
        this.goTo(this.index + 1 > this.count - 1 ? 0 : this.index + 1, false);
      }, this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (!this.autoplay || this.reduced) return;
      this.start();
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev(true));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next(true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10), true));
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(true); }
      });

      if (this.autoplay) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.restart());
        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stop() : this.restart();
        });
      }

      if (this.swipeEnabled && this.count > 1) this.bindSwipe();
    }

    bindSwipe() {
      let startX = 0;
      let startY = 0;
      let dx = 0;
      let dragging = false;
      let decided = false;
      let horizontal = false;

      const width = () => this.viewport.getBoundingClientRect().width || 1;

      const setDrag = (px) => {
        /* Fade modes follow the finger loosely; slide mode tracks it 1:1. */
        const factor = this.mode === 'slide' ? 1 : 0.28;
        this.slides.forEach((s) => s.style.setProperty('--cbs-drag', `${px * factor}px`));
      };

      const clearDrag = () => {
        this.slides.forEach((s) => s.style.removeProperty('--cbs-drag'));
      };

      this.viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX;
        startY = e.clientY;
        dx = 0;
        dragging = true;
        decided = false;
        horizontal = false;
        this.stop();
      });

      this.onPointerMove = (e) => {
        if (!dragging) return;
        dx = e.clientX - startX;
        const dy = e.clientY - startY;

        if (!decided) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          horizontal = Math.abs(dx) > Math.abs(dy);
          decided = true;
          if (horizontal) this.classList.add('is-dragging');
        }

        if (!horizontal) return;
        if (e.cancelable) e.preventDefault();

        /* Resist dragging past the ends when looping is off */
        let eff = dx;
        const atStart = this.index === 0 && dx > 0;
        const atEnd = this.index === this.count - 1 && dx < 0;
        if (!this.loop && (atStart || atEnd)) eff = dx * 0.25;

        setDrag(eff);
      };

      this.onPointerUp = () => {
        if (!dragging) return;
        dragging = false;
        this.classList.remove('is-dragging');

        if (horizontal) {
          const threshold = Math.min(80, width() * 0.15);
          clearDrag();
          if (dx <= -threshold) this.next(true);
          else if (dx >= threshold) this.prev(true);
          else this.restart();
        } else {
          clearDrag();
          this.restart();
        }

        dx = 0;
        decided = false;
        horizontal = false;
      };

      window.addEventListener('pointermove', this.onPointerMove, { passive: false });
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
    }
  }

  if (!customElements.get('collection-banner-slider')) {
    customElements.define('collection-banner-slider', CollectionBannerSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
